<template>
  <div>
    <a-drawer
      title="管理数据权限"
      width="640px"
      placement="right"
      :closable="false"
      :visible="access_visible"
      @close="onCloseDrawer"
    >
      <div style="padding: 10px">
        <div>
          <div
            v-for="(item, index) in list"
            :key="item.type"
            style="margin-bottom: 12px"
          >
            {{ item.title }}
            <div
              class="form-cell-box"
              v-for="(itemy, indey) in item.list"
              :key="`${itemy.type}_${itemy.desc}`"
              style="margin-bottom: 0px; margin-top: 4px"
            >
              <div
                class="class-title"
                style="width: 120px; text-align: left; margin-left: 20px"
              >
                {{ itemy.desc }}
              </div>
              <div style="height: 33px; line-height: 33px">
                <a-radio-group
                  @change="hcRadioP($event, indey, index)"
                  name="radioGroup"
                  :value="itemy.radio_status"
                >
                  <a-radio :value="0" style="width: 150px">
                    系统默认(近{{ itemy.default }}天)
                  </a-radio>
                  <a-radio :value="1"> 自定义 </a-radio>
                </a-radio-group>
                <template v-if="itemy.radio_status == 1">
                  <a-input-number v-model="itemy.day" :min="0" />
                  <span style="margin-left: 10px">天</span>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div style="color: red; height: 23px; width: 100%"></div>

        <div class="form-cell-box" style="margin-top: 30px; padding-left: 25px">
          <a-button
            @click="addRequest"
            :loading="add_button_loading"
            type="primary"
            style="margin-right: 20px"
            >确认</a-button
          >
          <a-button @click="onCloseDrawer">取消</a-button>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { UserDataAccess, UserAccessAdd } from "@/request/api";
export default {
  name: "userAccessDrawer",
  props: ["modal_visible"],
  data() {
    return {
      access_visible: false,
      add_button_loading: false,
      h_cost_type: 0,
      h_cost: 0,
      // 数据权限类型：1=投放跟踪:搜索日期范围，2 =数据看板:搜索日期范围，3=公众号订单:搜索日期范围，4=投放跟踪:后续Dn留存天数
      list: [
        {
          title: "推广效果跟踪",
          type: 1,
          list: [
            {
              radio_status: 0,
              day: 0,
              type: 1,
              title: "推广效果跟踪",
              desc: "搜索日期范围",
              default: 90,
            },
            {
              radio_status: 0,
              day: 0,
              type: 4,
              title: "推广效果跟踪",
              desc: "后续Dn留存天数",
              default: 7,
            },
          ],
        },

        {
          title: "推广数据看板",
          type: 2,
          list: [
            {
              radio_status: 0,
              day: 0,
              type: 2,
              title: "推广数据看板",
              desc: "搜索日期范围",
              default: 90,
            },
          ],
        },

        {
          title: "公众号订单",
          type: 3,
          list: [
            {
              radio_status: 0,
              day: 0,
              type: 3,
              title: "推广数据看板",
              desc: "搜索日期范围",
              default: 2,
            },
          ],
        },
         {
          title: "巨量看板",
          type: 5,
          list: [
            {
              radio_status: 0,
              day: 0,
              type: 5,
              title: "巨量看板",
              desc: "搜索日期范围",
              default: 90,
            },
          ],
        },
      ],
      r_user_id: null,
    };
  },
  methods: {
    showDrawer(item) {
      let that = this;
      that.$emit("access-loading-handle", true);
      that.r_user_id = item.id;
      UserDataAccess({
        user_id: item.id,
      }).then((res) => {
        that.$emit("access-loading-handle", false);
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          // 8011表示内容为空
          that.access_visible = true;
          if (res.data.data.data) {
            let data = res.data.data.data;
            for (let index = 0; index < that.list.length; index += 1) {
              data.forEach((res) => {
                that.list[index].list.forEach((re_z) => {
                  if (res.type == re_z.type) {
                    re_z.radio_status = 1;
                    re_z.day = res.day;
                  }
                });
              });
            }
          }
        } else if (res.data.code == 401) {
          // 未登录
          localStorage.removeItem("access_token");
          that.$router.replace({ name: "login", params: { type: "not_log" } });
        } else {
          that.$message.error(`错误：${res.data.msg}`);
        }
      });
    },
    hcRadioP(e, indey, index) {
      this.list[index].list[indey].radio_status = e.target.value;
    },
    addRequest() {
      let that = this;
      const list = [];
      const content = [];
      for (let index = 0; index < this.list.length; index++) {
        list.push(...this.list[index].list);
      }
      for (let i = 0; i < list.length; i++) {
        if (list[i].radio_status == 1 && list[i].day <= 0) {
          that.$message.warning(
            `${list[i].title}-${list[i].desc} 自定义天数不能为0`
          );
          return;
        }
        if (list[i].radio_status == 1) {
          content.push({
            type: list[i].type,
            day: list[i].day,
          });
        }
      }
      that.add_button_loading = true;
      UserAccessAdd({
        user_id: that.r_user_id,
        content: content,
      }).then((res) => {
        that.add_button_loading = false;
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          // 8011表示内容为空
          that.$message.success("操作成功");
          that.onCloseDrawer();
          that.$emit("access-success-handle");
        } else {
          that.$message.error(`错误：${res.data.msg}`);
        }
      });
    },
    onCloseDrawer() {
      this.add_button_loading = false;
      this.access_visible = false;
      for (let index = 0; index < this.list.length; index += 1) {
        this.list[index].list.forEach((item) => {
          item.radio_status = 0;
          item.day = 0;
        });
      }
    },
  },
};
</script>

<style scoped></style>
